import { RoundedInputField } from '@/shared/ui/RoundedInputField'
import { Box, Popper, useTheme } from '@mui/material'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import React from 'react'
import SearchBarIcons from '../../../shared/ui/SearchBarIcons'
import { useTranslation } from 'react-i18next'
import { minCharSearchLimit } from '@/shared/constants/appConstants'
import { useSearchBarLogic } from '../hooks/useSearchBarLogic'
import { PopperSearchResult } from '@/features/SearchBar/ui/components/PopperSearchResults'

const SearchBar = (): JSX.Element => {
    const { t: translate } = useTranslation()
    const theme = useTheme()
    const {
        handlePopperClick,
        handlePopperClose,
        handleInputChange,
        anchorEl,
        searchValue,
        setSearchValue,
        channelsData,
        open,
        id,
        isUserLoggedIn,
    } = useSearchBarLogic()

    const popperOffset = [42, 12]

    const popperContainerStyle = {
        padding: '24px 24px 32px 24px',
        backgroundColor: 'custom.midGray',
        zIndex: 9,
        width: 'max-content',
        boxShadow: '0px 4px 39px 0px #00000040',
        borderRadius: theme.shape.borderRadius,
        top: '16px',
    }

    const searchResultContainerStyle = {
        maxHeight: 'unset',
    }

    const popperModifiers = [
        {
            name: 'offset',
            options: {
                offset: popperOffset,
            },
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 30,
                boundariesElement: 'viewport',
            },
        },
    ]

    const containerStyle = {
        width: '100vw',
        maxWidth: { xs: '100px', sm: '200px', md: '385px' },
    }

    return (
        <ClickAwayListener onClickAway={handlePopperClose}>
            <Box sx={containerStyle}>
                <RoundedInputField
                    placeholder={translate('search')}
                    tooltip={
                        searchValue.length < minCharSearchLimit
                            ? translate('searchInputTooltip')
                            : ''
                    }
                    isCharactersLimit={true}
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                    icons={<SearchBarIcons />}
                    onChange={handleInputChange}
                    onClick={handlePopperClick}
                    disabled={!isUserLoggedIn}
                />
                {searchValue.length >= minCharSearchLimit && (
                    <Popper
                        id={id}
                        open={!!searchValue && open}
                        anchorEl={anchorEl}
                        sx={popperContainerStyle}
                        placement="bottom-end"
                        modifiers={popperModifiers}>
                        <Box sx={searchResultContainerStyle}>
                            <PopperSearchResult
                                channels={channelsData}
                                query={searchValue}
                                onClick={handlePopperClose}
                            />
                        </Box>
                    </Popper>
                )}
            </Box>
        </ClickAwayListener>
    )
}

export { SearchBar }
